import { useEffect } from 'react';
import { logError } from '@edx/frontend-platform/logging';
import { getConfig } from '@edx/frontend-platform';

const Logout = (): null => {
  const handleLogout = async () => {
    const { LOGOUT_URL } = getConfig();

    try {
      await fetch(LOGOUT_URL, { method: 'GET', credentials: 'include' });
    } catch (e) {
      logError('Logout request failed', e);
    }

    window.location.replace(window.location.origin);
  };

  useEffect(() => {
    handleLogout();
  }, []);

  return null;
};

export default Logout;
